export default {
    title: "Lieferbestätigung",
    header: "@:views.survey.delivery.title",
    result: {
        header: "Danke",
        message: "Vielen Dank für Ihre Antwort."
    },
    status: {
        yes: "Bitte überprüfen Sie die unten markierten Produkte, um die Lieferung zu bestätigen, und deaktivieren Sie die Produkte, die Sie nicht erhalten haben. Klicken Sie anschließend zur Bestätigung auf „Senden“.",
        no: "Bitte bestätigen Sie, dass Sie keines der unten aufgeführten Produkte erhalten haben. Falls Sie eines dieser Produkte erhalten haben, aktivieren Sie bitte das Kontrollkästchen neben dem/den erhaltenen Produkt(en) und klicken Sie zur Bestätigung auf „Senden“."
    },
    model: {
        checked: {
            label: "Erhalten"
        }
    },
    button: {
        submit: {
            cta: "Einreichen",
            processing: "Absenden"
        }
    }
}